import React, { ReactElement } from 'react';
import { Control, DeepMap, FieldError, useForm } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import { Translations } from './configuration';
import { Typography } from '@material-ui/core';
import {
  AppSelect,
  AppTextField,
  AppSwitch,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { SchemeTypes } from '../../../../config';
import { getState } from '../../../../redux/store';
import { ReducerKeys } from '../../../../redux/reducers';
import { FormFields } from '../../configuration';

interface IProps {
  mode: 'VIEW' | 'EDIT';
  errors: DeepMap<FormFields, FieldError>;
  control: Control<FormFields>;
}

interface IElementsProps {
  size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  element: ReactElement;
  id: string;
  rowStyle?: any;
}

export default function IdentificationDetailsForm(props: IProps): ReactElement {
  // console.log('Render IdentificationDetailsForm');
  const mode = props.mode;
  // const SCHEME_TYPE = props.scheme_type;
  // const IS_AGENT = props.is_agent;
  const errors = props.errors;
  const control = props.control;
  // const isExcluded = props.isExcluded;

  function handleFormElements(): IElementsProps[] {
    return [
      {
        element: renderVatNumberField(errors, control, mode),
        size: 4,
        id: 'vatNum',
      },
      {
        element: renderCompanyNameField(errors, control, mode),
        size: 8,
        id: 'company',
      },
      {
        element: renderVatReturnId(errors, control, mode),
        size: 3,
        id: 'vatReturnId',
      },
      {
        element: renderVatReturnVersionIdField(errors, control, mode),
        size: 3,
        id: 'vetReturnVersionId',
      },
      {
        element: renderVatReturnReference(errors, control, mode),
        size: 6,
        id: 'vatReturnReference',
      },
    ];
  }

  const elements = handleFormElements();

  return (
    <div>
      <Typography variant="h5">
        <TranslatedText textMap={Translations.identification_details_header} />
      </Typography>
      <div style={{ width: '100%' }}>
        <GridLayout elements={elements} />
      </div>
    </div>
  );
}

const renderVatNumberField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT'
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="identificationDetails_vatNumber"
      label={<TranslatedText textMap={Translations.vat_number_control} />}
      error={'identificationDetails_vatNumber' in errors}
      name="identificationDetails_vatNumber"
      control={control}
      rules={{ required: 'Required Field' }}
      helperText={
        errors.identificationDetails_vatNumber &&
        errors.identificationDetails_vatNumber.message
      }
      disabled={true}
    />
  );
};

const renderCompanyNameField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT'
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="identificationDetails_companyName"
      label={<TranslatedText textMap={Translations.company_name_control} />}
      error={'identificationDetails_companyName' in errors}
      name="identificationDetails_companyName"
      control={control}
      rules={{ required: 'Required Field' }}
      helperText={
        errors.identificationDetails_companyName &&
        errors.identificationDetails_companyName.message
      }
      disabled={true}
    />
  );
};

const renderVatReturnId = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT'
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="identificationDetails_vatReturnId"
      label={<TranslatedText textMap={Translations.vat_return_id} />}
      error={'identificationDetails_vatReturnId' in errors}
      name="identificationDetails_vatReturnId"
      type={'number'}
      control={control}
      rules={{ required: 'Required Field' }}
      helperText={
        errors.identificationDetails_vatReturnId &&
        errors.identificationDetails_vatReturnId.message
      }
      disabled={true}
    />
  );
};

const renderVatReturnVersionIdField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT'
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="identificationDetails_vatReturnVersionId"
      label={<TranslatedText textMap={Translations.vat_return_version_id} />}
      error={'identificationDetails_vatReturnVersionId' in errors}
      name="identificationDetails_vatReturnVersionId"
      type={'number'}
      control={control}
      rules={{ required: 'Required Field' }}
      helperText={
        errors.identificationDetails_vatReturnVersionId &&
        errors.identificationDetails_vatReturnVersionId.message
      }
      disabled={true}
    />
  );
};

const renderVatReturnReference = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>,
  mode: 'VIEW' | 'EDIT'
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      required
      fullWidth
      id="identificationDetails_vatReturnReference"
      label={<TranslatedText textMap={Translations.vat_return_reference} />}
      error={'identificationDetails_vatReturnReference' in errors}
      name="identificationDetails_vatReturnReference"
      control={control}
      rules={{ required: 'Required Field' }}
      helperText={
        errors.identificationDetails_vatReturnReference &&
        errors.identificationDetails_vatReturnReference.message
      }
      disabled={true}
    />
  );
};
